import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CalendarService } from 'src/app/pages/calendar/services/calendar.service';
import { BalanceService } from 'src/app/services/balance.service';
import { CartServiceService } from 'src/app/services/cart-service.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { StorageService } from 'src/app/services/storage.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dispatch',
  templateUrl: './dispatch.component.html',
  styleUrls: ['./dispatch.component.scss'],
})
export class DispatchComponent implements OnInit, OnDestroy {
  @Input() list: any[] = [];
  @Input() total: number = 0;
  @Input() paramDispatch: any;
  @Input() isService = false;
  @Output() nextPay = new EventEmitter();
  @Output() scrollBottom = new EventEmitter();

  public selectedWpp = undefined;
  public fieldForms: any[] = [];
  public currency = undefined;
  public message = undefined;
  public showDates = undefined;
  public scheduleDispatch = [];
  public tax = 0;
  public percent = 0;
  public priceWithTax = 0;
  public canSend = false;
  public totalTaxProducts = 0;
  public deliveryAmount = 0;
  private _domainId = environment.domainId;
  private _typeOrden = undefined;
  private _typeOrdenName = undefined;
  private _schedules: any[] = [];
  private _currencyObs: Subscription = undefined;

  constructor(
    public balanceSv: BalanceService,
    public loginSv: LoginService,
    public paramSv: ParamServicesService,
    private modalCtrl: ModalController,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private formSv: FormServices,
    private storageSv: StorageService,
    private calendarSv: CalendarService,
    private translateSv: TranslateService,
    private cartSv: CartServiceService
  ) {}

  async ngOnInit() {
    this._currencyObs = this.balanceSv.currencySource.subscribe((currency) => {
      this.currency = currency;
    });
    this.priceWithTax = this.total;
    if (this.balanceSv.currency) {
      this.currency = this.balanceSv.currency;
    }

    const data = await this.httpSv.itemIndex('attentionSchedule', '');
    if (data) {
      this._schedules = data.data.item;
    }
    this.getForm(this.isService ? 'ordenServices' : 'orden');
    this.canSend = this.isService ? true : false;
    this.calcTaxProducts();
    console.log('this.list :>> ', this.list);
  }

  calcTaxProducts() {
    this.list.forEach((item) => {
      this.totalTaxProducts += (item.price * (item.product?.tax || 0)) / 100;
    });
  }

  ngOnDestroy(): void {
    this._currencyObs.unsubscribe();
  }

  async getForm(name, canSend?, formCount?: any[]) {
    this.deliveryAmount = 0;
    if (canSend) {
      const form = formCount?.find(
        (item) => item.fieldName === 'branchContactId'
      );
      if (form) {
        const branch = form.select.find((item) => item.id === name);
        const tax = branch.tax;
        this.percent = +((this.total * tax) / 100).toFixed(2);
        this.priceWithTax = this.total + this.percent;
        this.tax = tax;
        console.log('this.priceWithTax :>> ', this.priceWithTax);
        if (tax) {
          const msg = this.translateSv.instant(
            'SE_COBRARA_UN_MONTO_ADICIONAL_SOBRE_EL_TOTAL_DEL',
            {
              tax,
            }
          );
          await this.uiSv.presentAlert(
            `${branch.name} - ${this.paramDispatch.comission || msg}`,
            false
          );
        }

        if (branch.amount && this._typeOrden === 'ordenDelivery') {
          this.deliveryAmount = branch.amount;
          const msg = this.translateSv.instant('DELIVERY_MSG', {
            value: `${
              this.balanceSv.currency?.symbol || this.balanceSv.currencyBaseName
            } ${branch.amount}`,
          });
          await this.uiSv.presentAlert(msg, false);
        }
        if (!this.isService) {
          this.scrollBottom.emit();
        }
      }
      return;
    }
    this.tax = 0;
    this.percent = 0;
    this._typeOrden = name;

    const form: any[] = await this.formSv.getForm(name, this._domainId);
    this.message = this.paramDispatch?.dispatchesType?.find(
      (item) => item.id === name
    )?.value;
    if (this.fieldForms.length < 1 && !this.isService) {
      this.fieldForms.push({ canSend: false, form });
      if (!form.length) {
        this.getData(new FormData());
      }
    } else {
      this.showDates = !!form.find((item) => item.fieldName === 'date');
      if (this.showDates) {
        const schedule: any[] = await this.calendarSv.convertData();
        this.scheduleDispatch = schedule;
      }
      this.canSend = true;
      if (this.isService) {
        this.fieldForms.push({ canSend: true, form });
      } else {
        this.fieldForms[1] = { canSend: true, form };
      }
      if (!this.isService) {
        this.scrollBottom.emit();
      }
    }
  }

  getFormData() {
    this.formSv.getDataSrc.next();
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  changeNum(event) {
    this.selectedWpp = (<HTMLIonSelectElement>event.detail).value;
  }

  continue() {
    this.formSv.getDataSrc.next();
  }

  async getData(data: FormData) {
    try {
      const dispatch = this.translateSv.instant('DESPACHO');
      let cart = `${dispatch}: %0A%0A`;
      cart += this.cartSv.buildCartMessage(this.list);
      let typeOrdenSelect = '';
      let dataForm: any[] = [];

      if (this.fieldForms[0].form.length) {
        if (!this.isService) {
          this._typeOrdenName = this.fieldForms[0].form[0].labelValue;
          typeOrdenSelect = this.fieldForms[0].form[0].select.find(
            (opt) => opt.id === this._typeOrden
          ).name;
          dataForm = this.fieldForms[1].form;
        } else {
          dataForm = this.fieldForms[0].form;
        }
      } else {
        this._typeOrden = 'ordenDelivery';
        data.set('nameClient', this.loginSv.user.name || 'Invitado');
      }

      cart += `${
        this._typeOrdenName
      }: ${typeOrdenSelect}%0AMonto: ${this.priceWithTax.toFixed(2)}%0A`;
      for (const item of dataForm) {
        cart += `${item.labelValue}: ${data.get(item.fieldName)}%0A`;
      }
      cart += `%0A%0A`;
      data.set('typeOrden', this._typeOrden);
      data.set('products', JSON.stringify(this.list));
      data.set('amount', this.priceWithTax.toFixed(2));
      const date = data.get('date');
      if (date) {
        const canStore = await this.compareSchedule(date);
        if (!canStore) {
          return false;
        }
      }
      await this.uiSv.showLoading();
      const logined = this.cartSv.logined;
      //DEFINO SI EL USUARIO EXISTE PARA ENVIAR AL API O NO

      const route = logined ? 'purchase/order' : 'unSave/order';
      data.set('domainId', this._domainId.toString());
      data.set('deliveryAmount', this.deliveryAmount.toString());

      if (data.get('branchContactId')) {
        data.set('deliveryBranchId', data.get('branchContactId').toString());
        data.delete('branchContactId');
      }

      const res: any = await this.httpSv.itemAction(data, route, 'store');
      await this.filterAndSaveProductsCart(res);
      await this.uiSv.loading.dismiss();
      this.nextPay.emit({ data: res.data, cart });
    } catch (err) {
      console.error(err);
      await this.uiSv.loading.dismiss();
    }
  }

  async filterAndSaveProductsCart(res) {
    if (this.cartSv.logined) {
      const newCart = res.cart[0]?.products;
      await this.storageSv.set('cart', newCart);
      return newCart;
    } else {
      const listIds = this.list.map((item) => {
        return {
          branchContactId: item.branchContactId,
          id: item.id,
        };
      });
      const newCart = this.cartSv.cart.filter((object1) => {
        return !listIds.some((object2) => {
          if (this.paramDispatch.branch) {
            if (
              object1.id === object2.id &&
              object1.branchContactId === object2.branchContactId
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return object1.id === object2.id;
          }
        });
      });
      await this.storageSv.set('cart', newCart);
      return newCart;
    }
  }

  async compareSchedule(date) {
    const canDispatch = this.calendarSv.compareSchedule(date, this._schedules);
    if (!canDispatch) {
      const msg = this.translateSv.instant(
        'EL_HORARIO_SELECCIONADO_NO_ESTA_DISPONIBLE'
      );
      await this.uiSv.presentAlert(msg, false);
    }
    return canDispatch;
  }
}
